// A Mexican RFC (Registro Federal de Contribuyentes) is 12 uppercase
// alphanumeric characters for a legal entity (moral persona) or 13 for an
// individual (persona física). This intentionally does not validate the
// embedded birth/incorporation date or the homoclave checksum — the ticket
// only asks for the length + character-set shape, not a full RFC checksum.
const RFC_REGEX = /^[A-Z0-9]{12,13}$/;

/**
 * react-admin field validator for a Mexican RFC. The field is optional, so an
 * empty value passes; a non-empty value must match `RFC_REGEX`.
 */
export const isValidRfc = (value?: string | null) => {
  if (!value) return undefined;
  if (!RFC_REGEX.test(value)) {
    return {
      message: "crm.validation.invalid_rfc",
      args: { _: "RFC must be 12 or 13 uppercase alphanumeric characters" },
    };
  }
  return undefined;
};
